<template>
  <nav
    v-if="filters"
    class="m-filters__group"
  >
    <slot></slot>

    <div class="m-filters__filter" v-if="departments.length">
      <h3 class="a-h4" id="filter-discipline-label">{{ $t('filters.discipline') }}</h3>
      <ul class="m-filters__filter-list">
        <li>
          <div class="a-radio-btn">
            <input
              class="a-radio-btn__el"
              type="radio"
              name="filter-discipline"
              id="filter-discipline-all"
              :value="null"
              :checked="filterDepartment === null"
              @input="$emit('update:filterDepartment', $event.target.value === 'on' ? null : $event.target.value)"
              aria-describedby="filter-discipline-label"
            >
            <label class="a-radio-btn__main" for="filter-discipline-all">
              <span class="a-radio-btn__radio"></span>
              <span class="a-radio-btn__label">{{ $t('filters.show_all') }}</span>
            </label>
          </div>
        </li>
        <li v-for="department in departments" :key="department.id">
          <div class="a-radio-btn">
            <input
              class="a-radio-btn__el"
              type="radio"
              name="filter-discipline"
              :id="'filter-discipline-' + department.id"
              :value="department.id"
              :checked="filterDepartment === department.id"
              @input="$emit('update:filterDepartment', $event.target.value)"
              aria-describedby="filter-discipline-label"
            >
            <label class="a-radio-btn__main" :for="'filter-discipline-' + department.id">
              <span class="a-radio-btn__radio"></span>
              <span class="a-radio-btn__label" v-text="department.title"></span>
            </label>
          </div>
        </li>
      </ul>
    </div>

    <!-- Sub filters -->
    <template v-for="department in departments" :key="department.id">
      <div
        v-if="filterDepartment === department.id && (disciplinesTwoDeep(department).length || disciplinesThreeDeep(department).length)"
        class="m-filters__sub"
      >
        <div class="m-filters__filter" v-for="category in disciplinesThreeDeep(department)" :key="category.id">
          <h3 class="a-h5 m-filters__sub-title" :id="'filter-' + category.id + '-label'" v-text="category.title"></h3>
          <ul class="m-filters__filter-list">
            <li v-for="discipline in category.children" :key="discipline.id">
              <div class="a-checkbox">
                <input
                  class="a-checkbox__el"
                  type="checkbox"
                  :id="'filter-' + category.id + '-type-' + discipline.id"
                  :aria-describedby="'filter-' + category.id + '-label'"
                  :value="discipline.id"
                  v-model="localDisciplines"
                  @change="$emit('update:filterDisciplines', localDisciplines)"
                >
                <label class="a-checkbox__label" :for="'filter-' + category.id + '-type-' + discipline.id" v-text="discipline.title"></label>
              </div>
            </li>
          </ul>
        </div>

        <div
          v-if="disciplinesTwoDeep(department).length"
          class="m-filters__filter"
        >
          <h3 class="a-h5 m-filters__sub-title" :id="'filter-' + department.id + '-label'">{{ $t('filters.type') }}</h3>
          <ul class="m-filters__filter-list">
            <li v-for="discipline in disciplinesTwoDeep(department)" :key="discipline.id">
              <div class="a-checkbox">
                <input
                  class="a-checkbox__el"
                  type="checkbox"
                  :id="'filter-' + department.id + '-type-' + discipline.id"
                  :aria-describedby="'filter-' + department.id + '-label'"
                  :value="discipline.id"
                  v-model="localDisciplines"
                  @change="$emit('update:filterDisciplines', localDisciplines)"
                >
                <label class="a-checkbox__label" :for="'filter-' + department.id + '-type-' + discipline.id" v-text="discipline.title"></label>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </template>

    <div class="m-filters__filter" v-if="ages.length">
      <h3 class="a-h4" id="filter-age-label">{{ $t('filters.age') }}</h3>
      <ul class="m-filters__filter-list">
        <li v-for="age in ages" :key="age.id">
          <div class="a-checkbox">
            <input
              class="a-checkbox__el"
              type="checkbox"
              :id="'filter-age-' + age.id"
              aria-describedby="filter-age-label"
              :value="age.id"
              v-model="localAges"
              @change="$emit('update:filterAges', localAges)"
            >
            <label class="a-checkbox__label" :for="'filter-age-' + age.id" v-text="age.title"></label>
          </div>
        </li>
      </ul>
    </div>

    <!-- @TODO BVRDG-236 disabled at request by Rob.
    <div class="m-filters__filter" v-if="languages.length">
      <h3 class="a-h4" id="filter-language-label">{{ $t('filters.language_teacher') }}</h3>
      <ul class="m-filters__filter-list">
        <li v-for="language in languages" :key="language.id">
          <div class="a-checkbox">
            <input
              class="a-checkbox__el"
              type="checkbox"
              :id="'filter-language-' + language.id"
              aria-describedby="filter-language-label"
              :value="language.id"
              v-model="localLanguages"
              @change="$emit('update:filterLanguages', localLanguages)"
            >
            <label class="a-checkbox__label" :for="'filter-language-' + language.id" v-text="language.title"></label>
          </div>
        </li>
      </ul>
    </div> -->

    <!-- @TODO BVRDG-99
    <div class="m-filters__filter">
      <h3 class="a-h4" id="filter-type-label">{{ $t('filters.lesson_plan') }}</h3>
      <ul class="m-filters__filter-list">
        <li>
          <div class="a-checkbox">
            <input class="a-checkbox__el" type="checkbox" id="filter-type-1" aria-describedby="filter-type-label">
            <label class="a-checkbox__label" for="filter-type-1">Cursus</label>
          </div>
        </li>
        <li>
          <div class="a-checkbox">
            <input class="a-checkbox__el" type="checkbox" id="filter-type-2" aria-describedby="filter-type-label">
            <label class="a-checkbox__label" for="filter-type-2">Workshop</label>
          </div>
        </li>
        <li>
          <div class="a-checkbox">
            <input class="a-checkbox__el" type="checkbox" id="filter-type-3" aria-describedby="filter-type-label">
            <label class="a-checkbox__label" for="filter-type-3">Opleiding</label>
          </div>
        </li>
      </ul>
    </div>
    -->

    <div class="m-filters__filter" v-if="days.length">
      <h3 class="a-h4" id="filter-day-label">{{ $t('filters.day') }}</h3>
      <ul class="m-filters__filter-list">
        <li>
          <div class="a-radio-btn">
            <input
              class="a-radio-btn__el"
              type="radio"
              name="filter-day"
              id="filter-day-all"
              aria-describedby="filter-day-label"
              :value="null"
              :checked="filterDay === null"
              @input="$emit('update:filterDay', $event.target.value === 'on' ? null : $event.target.value)"
            >
            <label class="a-radio-btn__main" for="filter-day-all">
              <span class="a-radio-btn__radio"></span>
              <span class="a-radio-btn__label">{{ $t('filters.show_all') }}</span>
            </label>
          </div>
        </li>

        <li v-for="day in days" :key="day.id">
          <div class="a-radio-btn">
            <input
              class="a-radio-btn__el"
              type="radio"
              name="filter-day"
              :id="'filter-day-' + day.id"
              :value="day.id"
              :checked="filterDay === day.id"
              @input="$emit('update:filterDay', $event.target.value)"
              aria-describedby="filter-day-label"
            >
            <label
              class="a-radio-btn__main"
              :for="'filter-day-' + day.id"
            >
              <span class="a-radio-btn__radio"></span>
              <span class="a-radio-btn__label" v-text="day.title"></span>
            </label>
          </div>

          <!-- Sub filters -->
          <div
            v-if="filterDay === day.id && momentsWithDocs(day).length"
            class="m-filters__sub"
          >
            <div class="m-filters__filter">
              <h3 class="a-h5 m-filters__sub-title" :id="'filter-' + day.id + '-label'">{{ $t('filters.daypart') }}</h3>
              <ul class="m-filters__filter-list">
                <li v-for="moment in momentsWithDocs(day)" :key="moment.id">
                  <div class="a-checkbox">
                    <input
                      class="a-checkbox__el"
                      type="checkbox"
                      :id="'filter-' + day.id + '-type-' + moment.id"
                      :aria-describedby="'filter-' + day.id + '-label'"
                      :value="moment.id"
                      v-model="localMoments"
                      @change="$emit('update:filterMoments', localMoments)"
                    >
                    <label
                      class="a-checkbox__label"
                      :for="'filter-' + day.id + '-type-' + moment.id"
                      v-text="moment.title">
                    </label>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  props: {
    filters: {
      type: Object,
      required: true,
    },
    filterDepartment: {
      type: Number,
      default: null,
    },
    filterDisciplines: {
      type: Array,
      default: () => {
        return [];
      },
    },
    filterAges: {
      type: Array,
      default: () => {
        return [];
      },
    },
    filterDay: {
      type: Number,
      default: null,
    },
    filterMoments: {
      type: Array,
      default: () => {
        return [];
      },
    },
    filterLanguages: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },

  data: () => ({
    localDisciplines: [],
    localAges: [],
    localMoments: [],
    localLanguages: [],
  }),

  computed: {
    departments() {
      if (! this.filters || ! this.filters.disciplines) {
        return [];
      }

      // Don't filter for docs as the root department resets all filters.
      return this.filters.disciplines;
    },

    ages() {
      if (! this.filters || ! this.filters.ages) {
        return [];
      }

      return this.filters.ages.filter((age) => age.count > 0);
    },

    days() {
      if (! this.filters || ! this.filters.moments) {
        return [];
      }

      return this.filters.moments.filter((moment) => moment.count > 0);
    },

    languages() {
      if (! this.filters || ! this.filters.languages) {
        return [];
      }

      return this.filters.languages.filter((language) => language.count > 0);
    },
  },

  mounted() {
    this.localDisciplines = this.filterDisciplines.slice();
    this.localAges = this.filterAges.slice();
    this.localMoments = this.filterMoments.slice();
    this.localLanguages = this.filterLanguages.slice();
  },

  watch: {
    filterDisciplines() {
      this.localDisciplines = this.filterDisciplines.slice();
    },

    filterAges() {
      this.localAges = this.filterAges.slice();
    },

    filterMoments() {
      this.localMoments = this.filterMoments.slice();
    },

    filterLanguages() {
      this.localLanguages = this.filterLanguages.slice();
    },
  },

  methods: {
    disciplinesThreeDeep(department) {
      if (! department.children || ! department.children.length) {
        return []
      }

      // Create a local instance.
      let local = Object.assign({}, department);

      // Only select items that go three deep.
      const threeDeep = local.children.filter((category) => category.children && category.children.length);

      // Filter only for docs.
      return threeDeep.map((category) => {
        let local = Object.assign({}, category);

        local.children = local.children.filter((discipline) => discipline.count > 0)

        return local;
      });
    },

    disciplinesTwoDeep(department) {
      if (! department.children || ! department.children.length) {
        return []
      }

      // Create a local instance.
      let local = Object.assign({}, department);

      // Only select items that go two deep.
      const twoDeep = local.children.filter((category) => ! category.children || ! category.children.length);

      // Filter only for docs.
      return twoDeep.filter((category) => category.count > 0);
    },

    momentsWithDocs(day) {
      if (! day.children || ! day.children.length) {
        return []
      }

      // Create a local instance.
      let local = Object.assign({}, day);

      // Filter only for docs.
      return local.children.filter((category) => category.count > 0);
    },
  },
}
</script>
